<template>
  <div id="questionManage">
    <div class="select">
      <h4 class="title1">
        <span>&nbsp;&nbsp;筛选条件</span>
      </h4>
      <div class="selectColor">
        <div class="row">
            <el-row :gutter="15">
              <el-col :span="7">
                <el-row>
                  <el-col :span="7">
                    险种代码
                  </el-col>
                  <el-col :span="17">
                    <el-select filterable multiple v-model="showParams.riskCodes" placeholder="请选择">
                        <el-option v-for="item in riskList" :key="item.value" :label="item.riskCode" :value="item.riskCode"></el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="7">
                <el-row>
                  <el-col :span="7">险种名称</el-col>
                  <el-col :span="17">
                    <el-input class="input" v-model="showParams.riskLabel" placeholder="请输入险种名称"></el-input> 
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="7">
                <el-row>
                  <el-col :span="7">答案种类</el-col>
                  <el-col :span="17">
                    <el-select v-model="showParams.answerType" placeholder="请选择" >
                      <el-option label="全部" :value="null">全部</el-option>
                      <el-option label="单选" :value="1">单选</el-option>
                      <el-option label="多选" :value="2">多选</el-option>
                  </el-select>
                  </el-col>
                </el-row>
              </el-col>
          </el-row>
          <el-row :gutter="15">
              <!-- <el-col :span="6">
                所属地区
                <el-select v-model="showParams.manageCom" placeholder="请选择">
                  <el-option label="全部" :value="null">全部</el-option>
                  <el-option key="HO" label="全国" value="HO"></el-option>
                  <el-option v-for="item in ManageComOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-col> -->
              <el-col :span="7">
              <el-row>
                <el-col :span="7">主险/附加险</el-col>
                <el-col :span="17">
                  <el-select v-model="showParams.isMaster" placeholder="请选择">
                    <el-option label="全部" :value="null">全部</el-option>
                    <el-option label="主险" value="M">主险</el-option>
                    <el-option label="附险" value="A">附险</el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
              <el-col :span="7">
                <el-row>
                  <el-col :span="7">题目状态</el-col>
                    <el-col :span="17">
                      <el-select v-model="showParams.difficulty" placeholder="请选择">
                        <el-option label="全部" :value="null">全部</el-option>
                        <el-option label="生效" :value="0">生效</el-option>
                        <el-option label="失效" :value="1">失效</el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="7">
                <el-row>
                  <el-col :span="7">险种类别</el-col>
                  <el-col :span="17">
                    <el-select v-model="showParams.riskType" placeholder="请选择" >
                      <el-option label="全部" :value="null">全部</el-option>
                      <el-option label="普通产品销售资格" :value="'12'">普通产品销售资格</el-option>
                      <el-option label="分红产品销售资格" :value="'13'">分红产品销售资格</el-option>
                      <el-option label="特许产品销售资格" :value="'23'">特许产品销售资格</el-option>
                      <el-option label="专用产品销售资格" :value="'22'">专用产品销售资格</el-option>
                      <el-option label="标准产品销售资格" :value="'122'">标准产品销售资格</el-option>
                    </el-select>
                  </el-col>  
                </el-row>
              </el-col>
              <el-col :span="2">
                <el-button type="primary" @click="search()">筛选</el-button>
              </el-col>
          </el-row>
      </div>
        <!-- <div class="row">
          <el-row>
            <el-col :span="6">
              <el-row>
                <el-col :span="4">
                  险种代码
                </el-col>
                <el-col :span="16">
                   <el-select v-model="options" placeholder="请选择">
                    <el-option label="全部" :value="null">全部</el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="4">
                  险种名称
                </el-col>
                <el-col :span="16"> <el-input class="input" v-model="riskName" maxlength="6"></el-input> </el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="4">考试类型</el-col>
                <el-col :span="16">
                  <el-select v-model="options" placeholder="请选择">
                    <el-option label="全部" :value="null">全部</el-option>
                    <el-option label="新人" :value="0">新人</el-option>
                    <el-option label="地区" :value="1">地区</el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="6">主险/附加险</el-col>
                <el-col :span="14">
                  <el-select v-model="options" placeholder="请选择">
                    <el-option label="全部" :value="null">全部</el-option>
                    <el-option label="新人" :value="0">新人</el-option>
                    <el-option label="地区" :value="1">地区</el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-row>
                <el-col :span="4">所属地区</el-col>
                <el-col :span="16">
                  <el-select v-model="showParams.manageCom" placeholder="请选择">
                    <el-option label="全部" :value="null">全部</el-option>
                    <el-option key="HO" label="全国" value="HO"></el-option>
                    <el-option v-for="item in ManageComOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="4">所属地区</el-col>
                <el-col :span="16">
                  <el-select v-model="showParams.isEffective" placeholder="请选择">
                    <el-option label="全部" :value="null">全部</el-option>
                    <el-option label="生效" :value="0">生效</el-option>
                    <el-option label="失效" :value="1">失效</el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>

            <el-col :span="2" :offset="10">
              <el-button type="primary" @click="search()">筛选</el-button>
            </el-col>
          </el-row>
        </div> -->
      </div>
    </div>
    <div class="select">
      <h4 class="title1">
        <span>&nbsp;&nbsp;搜索</span>
      </h4>
      <div class="row">
        <el-row :gutter="15">
          <el-col :span="12">
            <el-input v-model="showParams.subject" />
          </el-col>
          <el-col :span="2" :offset="9">
            <el-button type="primary" @click="search()">搜索</el-button>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="result">
      <h4 class="title1">
        <span>&nbsp;&nbsp;题库列表</span>
        <span style="float:right;margin-right:20px;line-height:50px;">
          <!-- <el-button size="mini" @click="downloadTemp()">下载导入模板</el-button>
          <el-button size="mini" @click="batchTabEffective(0)" :disabled="batchShow">批量生效</el-button>
          <el-button size="mini" @click="batchTabEffective(1)" :disabled="batchInvalid">批量失效</el-button> -->
          <el-button size="mini" @click="batchDelete" :disabled="batchShow">删除所选择</el-button>
          <el-button size="mini" @click="show_save">新增</el-button>
          <el-upload class="upload-demo right" :action="fileUrl" :data="uploadData" ref="uploadAgent" :on-success="uploadSuccess" :headers="uploadHeader">
            <el-button size="mini">批量导入</el-button>
          </el-upload>
        </span>
      </h4>
      <div class="result_view">
        <el-table :data="result" style="width: 100%;" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column type="index" label="序号"> </el-table-column>
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-row>
                  <el-col :span="20">
                    <el-row>
                      <el-col :span="2">
                        题目内容
                      </el-col>
                      <el-col :span="22">
                        {{ props.row.subject }}
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <el-row v-for="(item, index) in props.row.questionOptions" :key="index">
                          <el-col :span="2">&nbsp;</el-col>
                          <el-col :span="22">
                            {{ item.optionName + '.' + item.optionDetail }}
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="3" :offset="1">
                    <el-row>
                      <el-col :span="10">
                        答案项
                      </el-col>
                      <el-col :span="2">
                        {{ props.row.answer }}
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column prop="subject" label="题目内容" width="150" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="riskCode" label="险种代码" width="150" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="riskName" label="险种名称" width="150" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="riskType" :formatter="formatterRiskType" label="险种类别" width="150" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="isMaster" :formatter="formatterMaster" label="主/附险" width="150" header-align="center" align="center"> </el-table-column>
          <!-- <el-table-column prop="difficulty" label="题目难度" header-align="center" :formatter="difficulty" align="center"> </el-table-column>
          <el-table-column prop="questionType" label="题目种类" header-align="center" :formatter="questionType" align="center"> </el-table-column> -->
          <el-table-column prop="answerType" label="答案种类" header-align="center" :formatter="answerType" align="center"> </el-table-column>
          <el-table-column prop="manageCom" label="所属地区" header-align="center" :formatter="manageCom" align="center"> </el-table-column>
          <el-table-column prop="isEffective" label="题目状态" header-align="center" :formatter="isEffective" align="center"> </el-table-column>
          <el-table-column width="220" label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <!-- <el-button size="mini" @click="Edit(scope.$index, scope.row)">编辑</el-button> -->
              <el-button v-if="scope.row.isEffective != '0'" size="mini" @click="Edit(scope.$index, scope.row)">编辑</el-button>
              <el-button size="mini" v-if="scope.row.isEffective == '0'" @click="tabEffective(scope.$index, scope.row, 1)">失效</el-button>
              <el-button size="mini" v-if="scope.row.isEffective != '0'" @click="tabEffective(scope.$index, scope.row, 0)">生效</el-button>
              <el-button size="mini" v-if="scope.row.isEffective != '0'" @click="Delete(scope.$index, scope.row)">删除</el-button>
              <!-- <el-button size="mini" @click="Delete(scope.$index, scope.row)">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog title="新增试题" :visible.sync="saveVisible" @close="close" :close-on-click-modal="false">
      <el-input type="textarea" validate-event v-model="saveAndUpdateReq.subject" placeholder="请输入题目内容" maxlength="200"></el-input>
      <div>
        <el-checkbox-group v-model="correctAnswer">
          <el-row v-for="item in optionCount" :key="item" class="option-row">
            <el-col :span="2">
              <el-checkbox :label="optionChar[item - 1]" class="checkbox"></el-checkbox>
            </el-col>
            <el-col :span="22">
              <el-input v-model="saveAndUpdateReq.options[item - 1]" placeholder="请输选项" maxlength="50"></el-input>
            </el-col>
          </el-row>
        </el-checkbox-group>
      </div>
      <div class="selectTip">在正确答案面前勾选可以多选</div>
      <el-row class="option-row">
        <el-col :span="15">
          <el-select filterable @change="changeSelect" class="opt-select" placeholder="所属险种" v-model="saveAndUpdateReq.riskCode">
            <el-option v-for="(item,indey) in riskList" :key="indey" :label="item.riskName" :value="item.riskCode"></el-option>
          </el-select>
        </el-col>
        <el-col :span="7" :offset="2">
          <!-- <el-select placeholder="题目难度" class="opt-select" v-model="saveAndUpdateReq.difficulty">
            <el-option label="简单题" :value="0" v-if="saveAndUpdateReq.manageCom == 'HO'">简单题</el-option>
            <el-option label="中等题" :value="1" v-if="saveAndUpdateReq.manageCom == 'HO'">中等题</el-option>
            <el-option label="困难题" :value="2">困难题</el-option>
          </el-select> -->
        </el-col>
      </el-row>
      <el-row class="option-row">
        <!-- <el-select class="opt-select" placeholder="题目种类" v-model="saveAndUpdateReq.questionType">
          <el-option label="通用" :value="0" v-if="saveAndUpdateReq.manageCom != 'HO'">通用</el-option>
          <el-option label="财险" :value="1" v-if="saveAndUpdateReq.manageCom == 'HO'">财险</el-option>
          <el-option label="人寿险" :value="2" v-if="saveAndUpdateReq.manageCom == 'HO'">人寿险</el-option>
        </el-select> -->
      </el-row>
      <!-- <el-row class="option-row"> <b>温馨提示:</b> 如果试题所属地区为全国，题目类别支持选择人寿和财险，如果选择了非全国，则题目类别只支持选择通用。 </el-row> -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="saveVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitQuestion">确 定</el-button>
      </div>
    </el-dialog>
    <div class="selectTip">在正确答案面前勾选可以多选</div>
    <el-dialog title="编辑试题" :visible.sync="updateVisible" @close="close" :close-on-click-modal="false">
      <el-input type="textarea" v-model="saveAndUpdateReq1.subject" placeholder="请输入题目内容"></el-input>
      <div>
        <el-checkbox-group v-model="correctAnswer">
          <el-row v-for="item in optionCount" :key="item" class="option-row">
            <el-col :span="2">
              <el-checkbox :label="optionChar[item - 1]" class="checkbox"></el-checkbox>
            </el-col>
            <el-col :span="22">
              <el-input v-model="saveAndUpdateReq1.options[item - 1]" placeholder="请输选项"></el-input>
            </el-col>
          </el-row>
        </el-checkbox-group>
      </div>

      <el-row class="option-row">
        <el-col :span="15">
          <el-select  @change="changeSelect" class="opt-select" placeholder="所属险种" v-model="saveAndUpdateReq1.riskCode">
            <el-option label="全部" :value="null">全部</el-option>
            <el-option v-for="(item,indez) in riskList" :key="indez" :label="item.riskName" :value="item.riskCode"></el-option>
          </el-select>
          <!-- <el-select class="opt-select" placeholder="所属地区" v-model="saveAndUpdateReq1.manageCom">
            <el-option key="HO" label="全国" value="HO"></el-option>
            <el-option v-for="item in ManageComOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select> -->
        </el-col>
        <el-col :span="7" :offset="2">
          <!-- <el-select placeholder="题目难度" class="opt-select" v-model="saveAndUpdateReq1.difficulty">
            <el-option label="简单题" :value="0" v-if="saveAndUpdateReq1.manageCom == 'HO'">简单题</el-option>
            <el-option label="中等题" :value="1" v-if="saveAndUpdateReq1.manageCom == 'HO'">中等题</el-option>
            <el-option label="困难题" :value="2">困难题</el-option>
          </el-select> -->
        </el-col>
      </el-row>
      <el-row class="option-row">
        <!-- <el-select class="opt-select" placeholder="题目种类" v-model="saveAndUpdateReq1.questionType">
          <el-option label="通用" :value="0" v-if="saveAndUpdateReq1.manageCom != 'HO'">通用</el-option>
          <el-option label="财险" :value="1" v-if="saveAndUpdateReq1.manageCom == 'HO'">财险</el-option>
          <el-option label="人寿险" :value="2" v-if="saveAndUpdateReq1.manageCom == 'HO'">人寿险</el-option>
        </el-select> -->
      </el-row>

      <div slot="footer" class="dialog-footer">
        <el-button @click="updateVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitEdit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <div>确认删除？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitDelete">确 定</el-button>
      </span>
    </el-dialog>
    <Pagination :count="count" @currentChange="currentChange" @offset="offset"></Pagination>
  </div>
</template>

<script>
import api from '@/modules/api.js';
import url from '@/modules/url.js';
import sessionStorage from '@/components/cache';
import getIP from '@/components/utils/getIP';
import Pagination from '@/pages/exam/examNew/components/pagination';
export default {
  name: 'questionManage',
  components: { Pagination },
  data() {
    return {
      pageList:[10,20,30,40],
      answerList:'',// 记录标签值
      riskList:[],
      daima: '',
      name: '',
      riskCode:'',
      riskName:'',
      riskLabel:'',
      riskCodes:'',
      options: [],
      // 试题选项
      optionCount: 4,
      optionChar: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'],
      tempOption: [],
      dialogVisible: false,
      row: '',
      // 机构选项
      ManageComOptions: null,
      // 页面展示所需的变量
      showParams: {
        subject: null,
        questionType: null,
        difficulty: null,
        manageCom: null,
        answer: null,
        isEffective: null,
        answerType: null,
        riskCodes:[],
        isMaster:null,
        riskType:null
      },
      // 查询返回的结果
      result: null,
      // 多选框选中的数据
      checkedQuestion: [],
      // 选中的问题的类型
      checkedQuestionEff: [],
      batchInvalid: true,
      batchShow: true,
      // 控制新增dialog的弹出
      saveVisible: false,
      // 控制更新dialog的弹出
      updateVisible: false,
      // 查询请求参数
      queryReq: {
        subject: '',
        questionType: '',
        difficulty: '',
        manageCom: '',
        isEffective: '',
        answerType: '',
        pageSize: 10,
        currentPage: 1,
        offset: 0,
        riskCodes:[],
        riskLabel:'',
        isMaster:'',
        riskType:null
      },
      // 新增和更新请求参数
      saveAndUpdateReq: {
        questionCode: null,
        subject: '',
        answer:'',
        questionType: "3",
        difficulty: null,
        manageCom: null,
        answerType: null,
        options: ['', '', '', ''],
        riskCode:'',
        riskLabel:null
      },
      saveAndUpdateReq1: {
        questionCode: '',
        subject: '',
        questionType: '3',
        difficulty: null,
        manageCom: null,
        answerType: null,
        options: ['', '', '', ''],
        riskCodes:'',
        riskLabel:''
      },
      // 删除的请求
      deleteReq: {
        questionCodes: []
      },
      // 更新试题状态
      updateEffectReq: {
        questionCode: '',
        Effective: ''
      },
      // 临时存放数据的对象
      form: {},
      // 新增是选中的正确选项
      correctAnswer: [],
      query: {},
      count: 0,
      // 上传
      uploadData: {
        domain: 'EXAM',
        buz: 'EXCEL',
        expired: 60,
        actions: '',
        buzId: '123',
        auth: 1
      },
      uploadHeader: {
        ComId: 'ebiz-agent',
        Authorization: 'Basic ' + sessionStorage.session_get('token'),
        'Accept-Device': 'NULL',
        'Accept-DeviceOS': 'NULL',
        'Accept-Location': 'NULL',
        'Accept-ISP': 'NULL',
        'Accept-StartTime': 'NULL',
        'Accept-TimeZone': -(new Date().getTimezoneOffset() * 60000),
        'Accept-Attr1': getIP.getBrowserInfo(),
        'Accept-Attr2': 'PC',
        'Accept-Attr3': '',
        'Real-Ip': getIP.getBrowserInfo(),
        'Accept-Attr4': 'NULL',
        'Accept-Attr6': sessionStorage.session_get('username')
      },
      fileUrl: ''
    };
  },
  watch: {
    checkedQuestionEff: {
      deep: true,
      immediate: true,
      handler: function(newVal, oldVal) {
        if (newVal.length === 0) {
          this.batchInvalid = true;
          this.batchShow = true;
        } else {
          if (newVal.indexOf('0') < 0) {
            this.batchInvalid = true;
            this.batchShow = false;
          } else if (newVal.indexOf('1') < 0) {
            this.batchInvalid = false;
            this.batchShow = true;
          } else {
            this.batchInvalid = true;
            this.batchShow = true;
          }
        }
      }
    }
  },
  computed: {
    checkReq: function() {
      if (
        this.saveAndUpdateReq.subject === '' ||
        this.saveAndUpdateReq.questionType === '' 
        // this.saveAndUpdateReq1.difficulty === '' ||
        // this.saveAndUpdateReq1.manageCom === ''
      ) {
        return 0;
      }
      if (this.saveAndUpdateReq.subject.length > 200) {
        return 1;
      }
      for (let key in this.saveAndUpdateReq.options) {
        if (this.saveAndUpdateReq.options[key].length > 50) {
          return 1;
        }
      }
      if (this.correctAnswer.length === 0) {
        return 2;
      }
      return null;
    }
  },
  methods: {
    currentChange(value) {
      this.queryReq.currentPage = value;
      this.queryReq.offset = (value - 1) * this.queryReq.pageSize;
      this.queryQuestion();
    },
    offset(value) {
      this.queryReq.pageSize = value;
      this.queryReq.currentPage = 1;
      this.queryReq.offset = 0;
      this.queryQuestion();
    },
    downloadTemp() {
      // 下载导入模板
      location.href = 'static/examTemp/导入试题.xls';
    },
    reset() {
      // 重置
      this.showParams.questionType = null;
      this.showParams.difficulty = null;
      this.showParams.manageCom = null;
      this.showParams.answerType = null;
      this.showParams.isEffective = null;
      this.showParams.subject = null;
      this.queryReq.offset = 0;
      this.queryQuestion();
    },
    close() {
      this.saveAndUpdateReq = {
        questionCode: '',
        subject: '',
        questionType: '',
        difficulty: null,
        manageCom: null,
        answerType: null,
        options: ['', '', '', '']
      };
      this.correctAnswer = [];
    },
    formatterRiskType(row){
      if(!row.riskType){
        return '-'
      }else{
        if(row.riskType == 12){
          return '普通产品销售资格'
        }else if(row.riskType==13){
          return '分红产品销售资格'
        }else if(row.riskType ==23){
          return '特许产品销售资格'
        }else if(row.riskType == 22){
          return '专用产品销售资格'
        }else if(row.riskType == 122){
          return '标准产品销售资格'
        }else{
          return '-'
        }
      }
    },
    manageCom(row, column, cellValue, index) {
      for (let item in this.ManageComOptions) {
        if (cellValue === this.ManageComOptions[item].value) {
          return this.ManageComOptions[item].label;
        }
      }
      if (cellValue === 'HO') {
        return '全国';
      }
      return '无';
    },
    questionType(row, column, cellValue, index) {
      if (cellValue === 0) {
        return '通用';
      } else if (cellValue === 1) {
        return '财险';
      } else {
        return '人寿';
      }
    },
    difficulty(row, column, cellValue, index) {
      if (cellValue === 0) {
        return '简单题';
      } else if (cellValue === 1) {
        return '中等题';
      } else {
        return '困难题';
      }
    },
    isEffective(row, column, cellValue, index) {
      if (cellValue === '0') {
        return '生效';
      } else {
        return '失效';
      }
    },
    answerType(row, column, cellValue, index) {
      if (cellValue === '1') {
        return '单选';
      } else {
        return '多选';
      }
    },
    // --------分页

    handleCurrentChange(value) {
      this.queryReq.currentPage = value;
      this.queryReq.offset = (value - 1) * this.queryReq.pageSize;
      this.queryQuestion();
    },
    // 选中的题
    handleSelectionChange(value) {
      this.checkedQuestion = [];
      this.checkedQuestionEff = [];
      for (let i = 0; i < value.length; i++) {
        this.checkedQuestion.push(value[i].questionCode);
        this.checkedQuestionEff.push(value[i].isEffective);
      }
    },
    // 删除
    Delete(index, row) {
      this.dialogVisible = true;
      this.row = row;
    },
    submitDelete() {
      this.deleteReq.questionCodes.push(this.row.questionCode);
      let that = this;
      api.post(url.deleteQuestion, this.deleteReq, function(res) {
        if (res.result.isSuccess) {
          that.$message({
            message: '删除成功',
            type: 'success'
          });
          that.queryQuestion();
        } else {
          that.$message({
            message: '删除失败',
            type: 'error'
          });
        }
        that.dialogVisible = false;
      });
    },
    //获取类型险种列表
    initRiskTypes(){
      let that = this
      api.post(url.initRiskTypes, {}, function(res) {
        if (res.result.isSuccess) {
          that.riskList = res.data 
        } else {
          that.$message({
            
          });
        }
      });
    },
    // 批量删除
    batchDelete() {
      let that = this;
      this.deleteReq.questionCodes = this.checkedQuestion;
      api.post(url.deleteQuestion, this.deleteReq, function(res) {
        if (res.result.isSuccess) {
          that.$message({
            message: '删除成功',
            type: 'success'
          });
          that.queryQuestion();
        } else {
          that.$message({
            message: '删除失败',
            type: 'error'
          });
        }
      });
    },
    // 编辑题目
    Edit(index, row) {
      this.updateVisible = true;
      this.saveAndUpdateReq = row;
      let options = [];
      for (let item in row.questionOptions) {
        options.push(row.questionOptions[item].optionDetail);
      }
      if(row.riskCode === 'CJI'){
        this.saveAndUpdateReq.riskLabel = '测试'
      }else if(row.riskCode === 'ASD'){
        this.saveAndUpdateReq.riskLabel = '意外'
        console.log('enterin',this.saveAndUpdateReq.riskLabel)
      }
      this.saveAndUpdateReq.options = options;
      this.saveAndUpdateReq1 = JSON.parse(JSON.stringify(this.saveAndUpdateReq));
      this.correctAnswer = row.answer.split(',');
    },
    // 提交编辑
    submitEdit() {
      this.saveAndUpdateReq1.answer = this.correctAnswer.toString();
      let that = this;
      if (this.checkReq !== null) {
        if (this.checkReq === 2) {
          that.$message({
            message: '请选择正确答案',
            type: 'error'
          });
        }
        if (this.checkReq === 1) {
          that.$message({
            message: '题目不超过200字且选项不超过50字',
            type: 'error'
          });
        }
        if (this.checkReq === 0) {
          that.$message({
            message: '题目和选项不能为空',
            type: 'error'
          });
        }
      } else {
        api.post(url.saveAndUpdateQuestion, this.saveAndUpdateReq1, function(res) {
          if (res.result.isSuccess) {
            that.saveAndUpdateReq1 = that.saveAndUpdateReq1 = {
              questionCode: '',
              subject: '',
              questionType: '',
              difficulty: '',
              manageCom: '',
              answerType: '',
              options: ['', '', '', '']
            };
            that.queryQuestion();
            that.$message({
              message: '更新成功',
              type: 'success'
            });
          } else {
            that.$message({
              message: '更新失败',
              type: 'error'
            });
          }
        });
        that.updateVisible = false;
      }
    },
    //格式化险种名称
    formatterMaster(row){
      if(row.isMaster === 'M'){
        row.isMaster = '主险'
      }else if(row.isMaster === 'A'){
        row.isMaster = '附险'
      }
      return row.isMaster
    },
    // 显示新增
    show_save() {
      this.saveVisible = true;
    },
    //选项切换
    changeSelect(row){
      if(row === 'CJI'){
        this.saveAndUpdateReq.riskLabel = '测试'
        this.saveAndUpdateReq1.riskLabel = '测试'
      }else if(row === 'ASD'){
        this.saveAndUpdateReq.riskLabel = '意外'
        this.saveAndUpdateReq1.riskLabel = '意外'
      }
    },
    // 提交题目
    submitQuestion() {
      this.saveAndUpdateReq.answer = this.correctAnswer.toString();
      let that = this;
      // if (this.checkReq !== null) {
        if (this.checkReq === 2) {
          that.$message({
            message: '请选择正确答案',
            type: 'error'
          });
          return 
        }
        if (this.checkReq === 1) {
          that.$message({
            message: '题目不超过200字且选项不超过50字',
            type: 'error'
          });
          return 
        }
        // if()
        // if (this.checkReq === 0) {
        //   that.$message({
        //     message: '题目和选项不能为空',
        //     type: 'error'
        //   });
        //   return 
        // }
        this.saveAndUpdateReq.options.forEach(item =>{
          if(!item.length){
            this.answerList = '1'
          }
        })
        if(this.answerList === '1'){
          that.$message({
            message: '题目选项不能为空',
            type: 'error'
          });
          this.answerList = ''
          return false
        }
        if(!this.saveAndUpdateReq.subject){
          that.$message({
            message: '题目不能为空',
            type: 'error'
          });
          return false
        }
        if(!this.saveAndUpdateReq.answer){
          that.$message({
            message: '答案不能为空',
            type: 'error'
          });
          return false
        }
      // } else {
        this.saveAndUpdateReq.questionType = '3'
        // console.log(this.saveAndUpdateReq,'saveAndUpdateReq')
        console.log(this.saveAndUpdateReq,'saveandreq')
        if(this.saveAndUpdateReq.riskCode){
          api.post(url.saveAndUpdateQuestion, this.saveAndUpdateReq, function(res) {
            if (res.result.isSuccess) {
              that.saveAndUpdateReq = {};
              that.queryQuestion();
              that.$message({
                message: '新增成功',
                type: 'success'
              });
              that.saveAndUpdateReq = {
                questionCode: '',
                subject: '',
                questionType: '',
                difficulty: null,
                manageCom: null,
                answerType: null,
                options: ['', '', '', '']
              };
              // that.queryQuestion();
            } else {
              that.saveAndUpdateReq = {
                questionCode: '',
                subject: '',
                questionType: '',
                difficulty: null,
                manageCom: null,
                answerType: null,
                options: ['', '', '', '']
              };
              that.$message({
                message: '新增失败',
                type: 'error'
              });
            }
          });
          that.saveVisible = false;
        }else{
          this.$message({
            message: '请选择题目所属险种',
            type: 'error'
          });
        }
      // }
    },
    // 查询题目
    queryQuestion() {
      // this.queryReq.questionType = this.showParams.questionType;
      this.queryReq.questionType ="3"
      this.queryReq.difficulty = null;
      this.queryReq.manageCom = this.showParams.manageCom;
      this.queryReq.answerType = this.showParams.answerType;
      this.queryReq.isEffective = this.showParams.difficulty;
      this.queryReq.subject = this.showParams.subject;
      this.queryReq.riskCodes = this.showParams.riskCodes
      this.queryReq.riskLabel = this.showParams.riskLabel
      this.queryReq.isMaster = this.showParams.isMaster
      this.query.riskType = this.showParams.riskType
      let that = this;
      api.post(url.queryQuestion, this.queryReq, function(res) {
        that.result = res.data.data;
        that.count = res.data.total;
      });
    },
    search() {
      this.queryReq.offset = 0;
      this.queryReq.riskType = this.showParams.riskType
      this.queryQuestion();
    },
    // 失效，生效
    tabEffective(index, row, value) {
      let that = this;
      this.updateEffectReq.Effective = value;
      this.updateEffectReq.questionCode = row.questionCode;
      api.post(url.tabEffective, this.updateEffectReq, function(res) {
        that.queryQuestion();
      });
    },
    batchTabEffective(tabType) {
      let that = this;
      this.updateEffectReq.Effective = tabType;
      this.updateEffectReq.questionCodes = this.checkedQuestion;
      api.post(url.tabEffective, this.updateEffectReq, function(res) {
        that.queryQuestion();
      });
    },
    initManageCom() {
      let that = this;
      api.post(url.initManageCom, {}, function(res) {
        that.ManageComOptions = res.data;
      });
    },
    uploadSuccess(res) {
      let that = this;
      if (res.result.isSuccess === true) {
        that.$refs.uploadAgent.clearFiles();
        // 上传完成，开始导入
        api.post(url.importQuestion, { path: api.urlDomin + res.data.fileId + '.' + res.data.ext }, function(res) {
          if (res.result.isSuccess === true) {
            // 获取全部代理人
            that.queryQuestion();
            that.$message({
              type: 'success',
              message: '导入成功'
            });
          } else {
            that.$message.error('导入失败');
          }
        });
      } else {
        that.$message.error(res.result.error);
        that.$refs.uploadAgent.clearFiles();
        // this.fileList = []
        // this.loading = false
      }
    }
  },
  mounted() {
    this.fileUrl = this.$uploadImg;
    this.initManageCom();
    this.queryQuestion();
    this.initRiskTypes();
  }
};
</script>

<style scoped>
.row {
  margin-top: 20px;
  padding-left: 20px;
  line-height: 50px;
}
.el-select {
  width: 100%;
}
.selectColor >>> .el-input {
  width: 88%;
}
.select >>> .el-input {
  width: 100% !important;
}
.el-row {
  margin-bottom: 8px;
}
#questionManage >>> .el-table .cell {
  white-space: nowrap;
}
.title1 {
  background: #e0e0e0;
  height: 50px;
  line-height: 50px;
  margin: 0px 0px 0px 0px;
}
.checkbox {
  position: relative;
  top: 10px;
}
.option-row {
  margin-top: 15px;
}
.select {
  background: #ffffff;
  padding-bottom: 1px;
}
.opt-select {
  width: 100%;
}
.selectColor {
  padding-bottom: 1px;
}
.row {
  margin: 8px 0px 15px 10px;
}
.result_view {
  min-height: 300px;
  height: auto;
  background: #ffffff;
}
.right {
  margin-left: 15px;
  float: right;
}
.my-pagination {
  float: right;
}
.red {
  color: red;
  border-color: red;
}
.selectTip{
  color:#ccc;
  font-size:13px;
  margin-left: 10PX;
}
</style>



// WEBPACK FOOTER //
// src/pages/exam/examManage/newQuestionManage.vue